import React from 'react';
import './Equipe2Skeleton.css';

const Bone = ({ w, h = 10, r = 6, className = '' }) => (
  <span className={`eq2-sk-bone ${className}`} style={{ width: w, height: h, borderRadius: r }} />
);

function SectionTitle({ w }) {
  return (
    <div className="eq2-sk-row eq2-sk-title">
      <Bone w={w} h={13} />
      <Bone w={22} h={16} r={999} />
    </div>
  );
}

function AreaCard({ chips }) {
  return (
    <div className="eq2-sk-card eq2-sk-card--area">
      <div className="eq2-sk-row">
        <Bone w={34} h={22} r={7} />
        <Bone w="45%" h={11} />
        <Bone w={18} h={14} r={999} className="eq2-sk-push" />
      </div>
      <div className="eq2-sk-chips">
        {Array.from({ length: chips }).map((_, i) => (
          <Bone key={i} w={90 + ((i * 23) % 40)} h={22} r={999} />
        ))}
      </div>
    </div>
  );
}

function CoordCard({ areas }) {
  return (
    <div className="eq2-sk-card eq2-sk-card--coord">
      <div className="eq2-sk-row">
        <Bone w={36} h={36} r={999} />
        <div className="eq2-sk-col">
          <Bone w="55%" h={12} />
          <Bone w="38%" h={8} />
        </div>
        <Bone w={22} h={22} r={7} />
      </div>
      {Array.from({ length: areas }).map((_, i) => (
        <div key={i} className="eq2-sk-sub">
          <div className="eq2-sk-row">
            <Bone w={30} h={20} r={6} />
            <Bone w="40%" h={10} />
            <Bone w={18} h={14} r={999} className="eq2-sk-push" />
          </div>
          <div className="eq2-sk-chips">
            <Bone w={96} h={20} r={999} />
            <Bone w={80} h={20} r={999} />
          </div>
        </div>
      ))}
    </div>
  );
}

/** Skeleton de carregamento da Gestão de equipe (grade principal + painel de técnicos). */
export function Equipe2Skeleton({ panelCollapsed = false }) {
  return (
    <div
      className={`equipe2-grid equipe2-grid--${panelCollapsed ? 'panel-collapsed' : 'panel-open'} eq2-sk`}
      role="status"
      aria-live="polite"
      aria-label="Carregando equipe"
    >
      <div className="equipe2-main eq2-sk-main">
        <section className="eq2-sk-section">
          <SectionTitle w={52} />
          <div className="eq2-sk-wrap">
            <AreaCard chips={2} />
            <AreaCard chips={3} />
            <AreaCard chips={1} />
          </div>
        </section>
        <section className="eq2-sk-section">
          <SectionTitle w={112} />
          <div className="eq2-sk-wrap">
            <CoordCard areas={3} />
            <CoordCard areas={2} />
            <CoordCard areas={3} />
            <CoordCard areas={1} />
          </div>
        </section>
      </div>
      <aside className="eq2-sk-panel">
        {panelCollapsed ? (
          <Bone w={22} h={22} r={7} />
        ) : (
          <>
            <div className="eq2-sk-row">
              <Bone w={90} h={12} />
              <Bone w={22} h={16} r={999} className="eq2-sk-push" />
            </div>
            <Bone w="100%" h={28} r={8} />
            {Array.from({ length: 9 }).map((_, i) => (
              <div key={i} className="eq2-sk-row">
                <Bone w={28} h={28} r={999} />
                <div className="eq2-sk-col">
                  <Bone w={`${55 + ((i * 11) % 30)}%`} h={10} />
                  <Bone w="35%" h={8} />
                </div>
              </div>
            ))}
          </>
        )}
      </aside>
    </div>
  );
}
